<template>
    <div v-if="loading && hash">
        {{$translate('Loading...')}} <v-progress-circular indeterminate color="primary" />
    </div>
    <div v-else-if="name">
        <h1>{{name}}</h1>

        <v-btn @click="stopWatching" v-if="!removed">{{$translate('Stop watching')}}</v-btn>
        <div v-else>{{$translate('Watch removed')}}</div>
    </div>
    <div v-else>
        {{$translate('Watch removed')}}
    </div>
</template>

<script>
export default {
    name: 'zoezi-unsubscribe',
    data: () => ({
        loading: true,
        name: null,
        watcher_id: null,
        removed: false
    }),
    computed: {
        hash() {
            return this.$route.query.watcher;
        }
    },
    methods: {
        stopWatching() {
            if (this.hash) {
                this.$api.post('/api/public/watch/remove', null, {hash: this.hash}).then(() => {
                    this.getWatcher();
                })
            }
        },
        getWatcher() {
            if (this.hash) {
                this.$api.get('/api/public/watch/get', {hash: this.hash}).then(r => {
                    this.loading = false;
                    this.name = r.name;
                    this.removed = !!r.removed;
                })
            }
        }
    },
    mounted() {
        this.getWatcher();
    }
}
</script>
